import $ from "jquery";
import ResetableInput from "./util/resetable_input";

$(document).on("turbolinks:load", function () {
  $("input[type=text][data-resetable]").each(function () {
    new ResetableInput($(this));
  });
});
